module.exports = __webpack_public_path__ + "static/media/info.ccecb529.svg";